"use client"

import React, { useEffect, useState } from "react"
import { useLanguage } from "@/components/i18n/language-provider"

export function TrendingHashtags({ onSelect }: { onSelect?: (tag: string) => void }) {
  const { t } = useLanguage()
  const [tags, setTags] = useState<any[]>([])

  useEffect(() => { fetchTags() }, [])

  async function fetchTags() {
    const res = await fetch('/api/hashtags/search', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ trending: true }) })
    const data = await res.json()
    setTags(data.tags || [])
  }

  function handleClick(tag: string) {
    if (onSelect) {
      // if a client function was passed (rare), call it
      try { onSelect(tag) } catch { /* ignore */ }
      return
    }
    // default behaviour for Server -> Client usage: navigate to discover
    if (typeof window !== 'undefined') {
      window.location.href = `/discover?tag=${encodeURIComponent(tag)}`
    }
  }

  return (
    <aside className="bg-card rounded-2xl p-5 border border-border/50 shadow-sm">
      <h3 className="font-semibold mb-3 flex items-center gap-2">
        <span className="w-6 h-6 rounded-lg animated-gradient flex items-center justify-center text-white text-xs">#</span>
        {t("postTrendingTitle")}
      </h3>
      <div className="flex flex-wrap gap-2">
        {tags.map(t => (
          <button key={t.tag} onClick={() => handleClick(t.tag)} className="px-3 py-1.5 bg-primary/8 hover:bg-primary/15 text-primary rounded-full text-sm font-medium transition-colors duration-200">#{t.tag}</button>
        ))}
        {tags.length === 0 && <p className="text-sm text-muted-foreground">{t("postNoTrendingNow")}</p>}
      </div>
    </aside>
  )
}
